const SignalROnFunctions = {
  RECEIVE_USER_HISTORY: 'ReceiveUserHistory',
  RECEIVE_ORG_USER: 'ReceiveOrgUser',
  RECEIVE_USER_PRIVATE_SETTINGS: 'ReceiveUserPrivateSettings',
  RECEIVE_USER_DESTROYED: 'ReceiveUserDestroyed',
  RECEIVE_EMERGENCY: 'ReceiveEmergency',
  RECEIVE_VERSION_IOS: 'ReceiveVersionIos',
  RECEIVE_EMERGENCY_MESSAGE: 'ReceiveEmergencyMessage',
  RECEIVE_MINI_ORG: 'ReceiveMiniOrganization',
  RECEIVE_ORGANIZATION: 'ReceiveOrganization',
  RECEIVE_ORG_JOIN_REQUESTS: 'ReceiveOrgJoinRequests',
  RECEIVE_ORG_SPEC: 'ReceiveOrgSpec',
  RECEIVE_PVD_CONFIG_CHANGED: 'ReceivePvdConfigChanged',
  RECEIVE_EMERGENCY_CONFIG_CHANGED: 'ReceiveEmergencyConfigChanged',
  RECEIVE_ORG_GROUP_USER_STATUSES: 'ReceiveOrganizationGroupUserStatuses',
  RECEIVE_USER_STATUS: 'ReceiveUserStatus',
  RECEIVE_VERSION_WEB_APP: 'ReceiveVersionWebApp',
  ADMIN_RECEIVE_ORG_USER_UPDATED: 'Admin_ReceiveOrgUserUpdated',
};

export default SignalROnFunctions;
